"use client";
import { Box, Flex, Text } from "@chakra-ui/react";
import { SectionTemplate } from "components/individuals/blocks";

export interface HighlightsSectionProps {
  bg: string;
  color: string;
  highlight: {
    highlight: string;
    description: string;
  }[];
}

export const HighlightsSection = ({
  bg,
  color,
  highlight,
}: HighlightsSectionProps) => {
  return (
    <SectionTemplate bg={bg}>
      <Flex
        flexDir={{
          base: "column",
          lg: "row",
        }}
        justify={"center"}
      >
        {highlight.map((content, idx) => (
          <>
            {idx > 0 && (
              <Box
                borderLeft={`1px solid ${color}`}
                height="auto"
                display={{
                  base: "none",
                  lg: "block",
                }}
                mx={10}
              />
            )}
            {idx > 0 && (
              <Box
                alignSelf={"center"}
                borderTop={`1px solid ${color}`}
                width="30%"
                display={{
                  base: "block",
                  lg: "none",
                }}
                my={5}
              />
            )}
            <Flex
              key={`highlight-${idx}`}
              color={color}
              flexDir={"column"}
              w={{
                lg: "35%",
              }}
            >
              <Text
                fontSize={{
                  base: "xl",
                  lg: "3xl",
                }}
                textAlign={"center"}
                fontWeight={"bold"}
                pb={{
                  base: 3,
                  lg: 5,
                }}
              >
                {content.highlight}
              </Text>
              <Text
                fontSize={{
                  base: 14,
                  md: 16,
                  lg: 17,
                  xl: 18,
                }}
              >
                {content.description}
              </Text>
            </Flex>
          </>
        ))}
      </Flex>
    </SectionTemplate>
  );
};
